import { StringObj, Params } from '@/libs/types';
import { axios } from '@/libs/api.request';

// 转后端对应的key
const keyPath: StringObj = {
    loginName: 'login_name',
    name: 'user_name',
    email: 'email',
    phone: 'phone',
    status: 'remember',
    password: 'password',
    oldPassword: 'old_password',
    newPassword: 'new_password',
    career: 'job_key',
    industry: 'industry_key',
    company: 'profile_company_name',
    timeZone: 'time_zone',
    language: 'language',
    translate_language: 'translate_language',
    invite_code: 'invite_code',
    location_time_zone: 'location_time_zone',
    sound_notice: 'sound_notice',
    sound_notice_interval: 'sound_notice_interval',
};

export interface getUserInfoParams {
    sys_user_id?: string;
    project_id?: string;
    login_type?: string;
}

// 获取用户信息
export const getUserInfo = (params?:getUserInfoParams) => {
    return axios.request({
        url: 'sys/user/profile/get-login-info',
        method: 'get',
        params,
    });
};

// 获取试用公司信息
export const getTrailCompanyInfo = () => axios.request({
    url: 'sys/admin/company/get-trail-company-info',
    method: 'get',
});

// 获取详细资料
export const getProfile = () => axios.request({
    url: 'sys/user/profile/get-profile',
    method: 'get',
});

// 试用公司升级购买正式套餐
export const upgradeApplication = (userNum: string | number, paymentChannelName: string, packageMonth: string | number, payChannelName: string, couponCode: string) => axios.request({
    url: '/sys/admin/company/upgrade-application',
    method: 'post',
    data: {
        user_num: userNum,
        package_month: packageMonth,
        payment_channel_name: paymentChannelName,
        product_name: 'Adspower',
        currency_code: 'USD',
        pay_channel_name: payChannelName || '',
        coupon_code: couponCode || '',
    },
});

// 获取试用公司套餐费用
export const getProbationPackageInfo = (userNum: string | number, packageMonth: string | number, couponCode: string) => axios.request({
    url: '/sys/admin/company/get-probation-package-info',
    method: 'post',
    data: {
        user_num: userNum,
        package_month: packageMonth,
        coupon_code: couponCode || '',
    },
});

// 发送绑定邮箱的验证码
export const sendBindEmail = (email: string) => axios.request({
    url: 'sys/user/profile/send-bind-email',
    method: 'post',
    data: {
        email,
    },
});

// 发送绑定手机的验证码
export const sendBindPhone = (phone: number) => axios.request({
    url: 'sys/user/profile/send-bind-phone',
    method: 'post',
    data: {
        phone,
    },
});

// 绑定手机
export const bindPhone = ({
    phone,
    code,
}: Params) => axios.request({
    url: 'sys/user/profile/bind-phone',
    method: 'post',
    data: {
        phone,
        code,
    },
});

// 更新用户料资
export const updateProfile = (params: Params) => {
    const keyArr = ['name', 'password', 'career', 'industry', 'company', 'timeZone', 'language', 'translate_language', 'invite_code', 'location_time_zone', 'sound_notice', 'sound_notice_interval'];
    const data: any = {};
    Object.keys(params).map((i) => {
        const isHas = keyArr.some((item: any) => item === i);
        if (isHas) {
            data[keyPath[i]] = params[i];
        }
        return i;
    });
    return axios.request({
        url: 'sys/user/profile/update-profile',
        method: 'post',
        data,
    });
};

// 获取客户经理
export const getManager = () => axios.request({
    url: 'sys/company/company/get-manager-data',
    method: 'get',
});

export interface Password {
    oldPassword: string;
    newPassword: string;
}
export const updatePassword = ({
    oldPassword,
    newPassword,
}: Password) => axios.request({
    url: 'sys/user/profile/update-password',
    method: 'post',
    data: {
        old_password: oldPassword,
        new_password: newPassword,
    },
});

interface BindEmailParams {
    email: string;
    verfiy_code: string;
    password?: string;
    invite_code?: string;
    type?: string; //  0-默认 1-修改邮箱
}
/**
 * 绑定邮箱
 */
export const bindEmail = (data: BindEmailParams) => axios.request({
    url: '/sys/user/profile/bind-email',
    method: 'post',
    data,
});

/**
 * 解绑微信
 */
export const unBindWechat = () => axios.request({
    url: '/sys/user/profile/unbind-weixin',
    method: 'post',
});

//
// 获取用户信息
export const updateUser = (data:{
    user_name: string;
    password: string;
}) => {
    return axios.request({
        url: 'sys/user/profile/update-user',
        method: 'post',
        data,
    });
};

export interface setPasswordData{
    email:string,
    password:string
}

/**
 * 谷歌登录设置邮箱密码
 * @param data
 */
export const setPassword = (data:setPasswordData) => axios.request({
    url: '/sys/user/profile/set-password',
    method: 'post',
    data,
});

/**
 * tg绑定
 */
export const telegramBind = (data: { data: string }) => axios.request({
    url: '/sys/user/profile/telegram-bind',
    method: 'post',
    data,
    customTips: true,
});

/**
 * fb绑定
 */
export const facebookBind = (data: { data: string }) => axios.request({
    url: '/sys/user/profile/facebook-bind',
    method: 'post',
    data,
});

/**
 * tg解绑
 * @param data
 * @returns
 */
export const telegramUnbind = (data: {id: string}) => axios.request({
    url: '/sys/user/profile/telegram-unbind',
    method: 'post',
    data,
});

/**
 * fb解绑
 * @param data
 * @returns
 */
export const facebookUnbind = (data: {id: string}) => axios.request({
    url: '/sys/user/profile/facebook-unbind',
    method: 'post',
    data,
});

/**
 * WhatsApp解绑
 * @param data
 * @returns
 */
export const whatsAppUnbind = () => axios.request({
    url: '/sys/user/profile/unbind-whatsapp',
    method: 'post',
});
